import { render, staticRenderFns } from "./UpdateChecker.vue?vue&type=template&id=74609870&scoped=true"
import script from "./UpdateChecker.vue?vue&type=script&lang=js"
export * from "./UpdateChecker.vue?vue&type=script&lang=js"
import style0 from "./UpdateChecker.vue?vue&type=style&index=0&id=74609870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74609870",
  null
  
)

export default component.exports